module.exports = __webpack_public_path__ + "img/fi.5fb32065.svg";